import BioZendoHealth from './BioZendoHealth';
import BioMadrone from './BioMadrone';
import BioYourPathTherapy from './BioYourPathTherapy';
import BioSoundMindSoundBody from './BioSoundMindSoundBody';

export default {
  BioZendoHealth,
  BioMadrone,
  BioYourPathTherapy,
  BioSoundMindSoundBody
};